const _temp0 = require("url:../../favicon/android-icon-192x192.png");
const _temp1 = require("url:../../favicon/apple-icon-114x114.png");
const _temp2 = require("url:../../favicon/apple-icon-120x120.png");
const _temp3 = require("url:../../favicon/apple-icon-144x144.png");
const _temp4 = require("url:../../favicon/apple-icon-152x152.png");
const _temp5 = require("url:../../favicon/apple-icon-180x180.png");
const _temp6 = require("url:../../favicon/apple-icon-57x57.png");
const _temp7 = require("url:../../favicon/apple-icon-60x60.png");
const _temp8 = require("url:../../favicon/apple-icon-72x72.png");
const _temp9 = require("url:../../favicon/apple-icon-76x76.png");
const _temp10 = require("url:../../favicon/favicon-16x16.png");
const _temp11 = require("url:../../favicon/favicon-32x32.png");
const _temp12 = require("url:../../favicon/favicon-96x96.png");
const _temp13 = require("url:../../favicon/ms-icon-144x144.png");
module.exports = {
  "android-icon-192x192": _temp0,
  "apple-icon-114x114": _temp1,
  "apple-icon-120x120": _temp2,
  "apple-icon-144x144": _temp3,
  "apple-icon-152x152": _temp4,
  "apple-icon-180x180": _temp5,
  "apple-icon-57x57": _temp6,
  "apple-icon-60x60": _temp7,
  "apple-icon-72x72": _temp8,
  "apple-icon-76x76": _temp9,
  "favicon-16x16": _temp10,
  "favicon-32x32": _temp11,
  "favicon-96x96": _temp12,
  "ms-icon-144x144": _temp13
}